var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f6ea3e3e-aeda-4beb-a0d8-79f6fd5ce89a",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 920.1 235.5",
    style: {
      enableBackground: "new 0 0 920.1 235.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:url(#SVGID_1_);stroke:url(#SVGID_00000110431308806450787910000006658755506996513924_);stroke-miterlimit:10;}\r\n\t\r\n\t\t.st2{fill:url(#SVGID_00000072244806545294893160000000863349599237041809_);stroke:url(#SVGID_00000011711337722363946480000003480320376831927702_);stroke-miterlimit:10;}\r\n\t\r\n\t\t.st3{fill:url(#SVGID_00000124150065184047013360000017005062868383378827_);stroke:url(#SVGID_00000150782816440265811040000008818812891092280204_);stroke-miterlimit:10;}\r\n\t\r\n\t\t.st4{fill:url(#SVGID_00000067202098799723890420000013089260172406505616_);stroke:url(#SVGID_00000139271553026651637640000004371392830134196412_);stroke-miterlimit:10;}\r\n\t\r\n\t\t.st5{fill:url(#SVGID_00000088091957380916385170000017736479028777507485_);stroke:url(#SVGID_00000002352806835210518860000016054803867949518212_);stroke-miterlimit:10;}\r\n\t.st6{fill:#233562;}\r\n\t.st7{fill:#48A397;}\r\n\t\r\n\t\t.st8{fill:url(#SVGID_00000118370891874842273080000003898949579662290105_);stroke:url(#SVGID_00000077319230122836439070000000065038691298058626_);stroke-miterlimit:10;}\r\n\t.st9{enable-background:new    ;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M321.7,69.9l1.4,0.3l0.9,0.2h0.3l0.9,0.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.1,70.6h-0.2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.8882,
    y1: 277.1503,
    x2: 376.5,
    y2: 277.1503,
    gradientTransform: "matrix(1 0 0 1 -36.5 -101.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48A397"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#35796D"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101787352493029389040000003283958642567407797_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.3882,
    y1: 275.8263,
    x2: 377.1577,
    y2: 275.8263,
    gradientTransform: "matrix(1 0 0 1 -36.5 -101.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48A296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#357B70"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)",
      stroke: "url(#SVGID_00000101787352493029389040000003283958642567407797_)",
      strokeMiterlimit: 10
    },
    d: " M340,179c-19.1,24.5-48.4,38.8-79.5,38.7l-5.9-0.2c-5.7-0.3-11.3-1.1-16.8-2.4l0,0c-4.8-5.4-9.2-11.1-13-17.2l0,0 c-0.9-1.5-1.9-3-2.7-4.6c-11.6-20-17-41.1-16.7-59.7c9.3,30.1,41.1,47.1,71.3,38l0,0c4.9-1.5,9.6-3.6,13.9-6.4l0,0 C308.4,160.3,327.4,165.6,340,179L340,179z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.5,67.8c2.3,0.8,4.5,1.7,6.7,2.8l-0.8-0.2H324l-0.9-0.2l-1.3-0.3L318.5,67.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.3,92c-1.4,0.4-2.9,0.6-4.4,0.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.7,127.7c-2.2-1.4-4.1-3.4-5.5-5.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.6,208.8c-2.4-1.9-4.5-4.1-6.3-6.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124855789367682817370000005216650244984382600_",
    gradientUnits: "userSpaceOnUse",
    x1: 274.1,
    y1: 68.75,
    x2: 196.3,
    y2: 68.75,
    gradientTransform: "matrix(1 0 0 -1 -36.5 210.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233562"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A63A8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081649984584109904340000003502072614516523178_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.5028,
    y1: 69.1142,
    x2: 195.7733,
    y2: 69.1142,
    gradientTransform: "matrix(1 0 0 -1 -36.5 210.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#243764"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#455E9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124855789367682817370000005216650244984382600_)",
      stroke: "url(#SVGID_00000081649984584109904340000003502072614516523178_)",
      strokeMiterlimit: 10
    },
    d: " M208.5,203.4c9,5.4,18.8,9.4,29.1,11.7c-4.8-5.4-9.1-11.1-12.9-17.2c-1-1.5-1.9-3-2.8-4.6c-11.5-19.9-17-41.1-16.6-59.7 c-7.6-24.7,2.3-51.4,24.2-65.2c-6.6,2-13.1,4.5-19.3,7.5c-9.5,4.5-18.5,10.2-26.6,16.9c-3.9,13.7-12.3,25.8-23.8,34.2 c1.5,14.6,6.2,28.8,13.7,41.4L208.5,203.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000117669791896130433620000005019460960908295582_",
    gradientUnits: "userSpaceOnUse",
    x1: 68,
    y1: 158.5,
    x2: 214.4,
    y2: 158.5,
    gradientTransform: "matrix(1 0 0 1 -36.5 -101.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48A397"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#35796D"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176017723820415955310000012410322148685741704_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.462,
    y1: 158.9708,
    x2: 214.9,
    y2: 158.9708,
    gradientTransform: "matrix(1 0 0 1 -36.5 -101.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48A296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#357B70"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000117669791896130433620000005019460960908295582_)",
      stroke: "url(#SVGID_00000176017723820415955310000012410322148685741704_)",
      strokeMiterlimit: 10
    },
    d: " M177.9,75.4c0,8.3-1.7,16.5-5,24.1c-2.3-7.5-6.1-14.4-11.2-20.3c-10.6-12.5-25-19.3-37.8-19.2c-2.5-1.3-5.2-2-8-2h-43 c-4.6,0-9.1-0.8-13.4-2.5c-15.3-6-26.6-21.9-28-41H117C150.6,14.5,177.8,41.7,177.9,75.4L177.9,75.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133507255372181687320000001765544423510172055_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.6731,
    y1: 240.301,
    x2: 236.6,
    y2: 240.301,
    gradientTransform: "matrix(1 0 0 1 -36.5 -101.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233562"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A63A8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001651561157260104960000013666792032281620647_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.1731,
    y1: 240.301,
    x2: 237.2853,
    y2: 240.301,
    gradientTransform: "matrix(1 0 0 1 -36.5 -101.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#243764"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#455E9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133507255372181687320000001765544423510172055_)",
      stroke: "url(#SVGID_00000001651561157260104960000013666792032281620647_)",
      strokeMiterlimit: 10
    },
    d: " M200.1,203.6c-14.5,16.5-39.3,18.7-56.5,5.1l0,0l-6.3-6.4l-72.6-74.6l-5.5-5.6l0,0c-5.7-8.9-3.1-20.7,5.7-26.4 c0.1,0,0.1-0.1,0.2-0.1c3.1-2,6.6-3,10.3-3l45-0.6l0,0c5.7-1.5,10.2-5.8,12-11.4l0,0c2.6-8-1-16.7-8.4-20.6 c12.8-0.1,27.2,6.7,37.8,19.2c5,6,8.8,12.9,11.1,20.3c-7.6,17.7-23.1,30.7-41.9,35.1l16.7,16.7L200.1,203.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005265664218101780460000011775634446894217647_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.94,
    y1: 276.05,
    x2: 154.24,
    y2: 276.05,
    gradientTransform: "matrix(1 0 0 1 -79.44 -91.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48A397"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#35796D"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132781880436139066870000016236391436697901206_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.44,
    y1: 276.05,
    x2: 154.74,
    y2: 276.05,
    gradientTransform: "matrix(1 0 0 1 -79.44 -91.25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#48A296"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#357B70"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005265664218101780460000011775634446894217647_)",
      stroke: "url(#SVGID_00000132781880436139066870000016236391436697901206_)",
      strokeMiterlimit: 10
    },
    d: " M53.2,151.9L53.2,151.9c11.9,0.1,21.6,9.8,21.6,21.7V196c0,11.9-9.7,21.6-21.6,21.7l0,0c-12,0-21.7-9.7-21.7-21.7v-22.4 C31.5,161.6,41.2,151.9,53.2,151.9L53.2,151.9z"
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M336,94.3v11.4l-2.8-0.2c-6.8,0-11.3,3.7-11.3,11.9v20h-12.3V94.9h11.8v5.7C324.4,96.4,329.4,94.3,336,94.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M384.3,119.7h-32.1c1.2,5.3,5.7,8.5,12.1,8.5c4,0.2,7.9-1.3,10.7-4.1l6.6,7.1c-4,4.5-9.9,6.9-17.6,6.9 c-14.7,0-24.2-9.3-24.2-21.9s9.7-21.9,22.7-21.9s22.1,8.4,22.1,22C384.6,117.3,384.4,118.6,384.3,119.7z M352,112.5h21 c-0.7-5.2-5.2-9.1-10.5-8.9C357.2,103.4,352.6,107.2,352,112.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M436.6,94.9v35.4c0,15.8-8.5,23.1-23.8,23.1c-8.1,0-15.9-2-20.9-5.9l4.9-8.8c4.4,3.1,9.6,4.8,15,4.8 c8.7,0,12.5-3.9,12.5-11.6v-1.8c-3.2,3.6-7.9,5.3-13.4,5.3c-11.8,0-21.3-8.1-21.3-20.5s9.5-20.6,21.3-20.6c5.9,0,10.8,2,14,6.1v-5.5 C424.9,94.9,436.6,94.9,436.6,94.9z M424.5,114.9c0-6.3-4.7-10.5-11.1-10.5s-11.3,4.2-11.3,10.5s4.8,10.4,11.3,10.4 S424.5,121.1,424.5,114.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M490.9,94.9v42.5h-11.7v-5c-3.4,3.7-8.2,5.8-13.2,5.7c-10.7,0-18.2-6-18.2-19.1V95h12.4v22.2 c0,7.1,3.1,10.2,8.6,10.2s9.8-3.6,9.8-11.4V95L490.9,94.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M502.4,78.8h12.3v58.6h-12.3L502.4,78.8L502.4,78.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M563.7,113.2v24.2h-11.5v-5.2c-2.3,3.8-6.7,5.9-13,5.9c-10,0-15.9-5.6-15.9-12.9s5.3-12.7,18.3-12.7h9.8 c0-5.3-3.2-8.4-9.8-8.4c-4.4,0-8.7,1.4-12.3,4l-4.3-8.6c4.6-3.3,11.5-5.1,18.3-5.1C556.2,94.3,563.7,100.3,563.7,113.2z M551.4,124 v-4.3H543c-5.8,0-7.6,2.1-7.6,5s2.6,5.1,7,5.1S550,127.9,551.4,124z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M602.3,135.4c-2.5,1.8-6.3,2.7-10,2.7c-10,0-15.9-5.2-15.9-15.3v-17.4h-6.6v-9.5h6.6V85.5h12.3v10.4h10.6v9.4 h-10.6v17.3c0,3.7,2,5.6,5.3,5.6c1.8,0.1,3.5-0.5,5-1.5L602.3,135.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M607.7,82.2c0-3.9,3.1-6.9,7.7-6.9s7.7,2.8,7.7,6.6c0,3.8-3.1,7.1-7.7,7.1S607.7,86,607.7,82.2z M609.3,94.9 h12.3v42.5h-12.3V94.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M629.9,116.2c0-12.8,9.8-21.9,23.4-21.9s23.2,9.1,23.2,21.9s-9.7,21.9-23.2,21.9S629.9,129,629.9,116.2z  M664.1,116.2c0-7.3-4.7-11.8-10.8-11.8s-11,4.4-11,11.8s4.8,11.8,11,11.8S664.1,123.5,664.1,116.2L664.1,116.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M728.2,113.1v24.3h-12.3V115c0-6.9-3.2-10-8.6-10s-10.2,3.6-10.2,11.5v21h-12.3V95h11.7v5 c3.3-3.7,8.3-5.7,14.1-5.7C720.6,94.3,728.2,100.2,728.2,113.1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M736.7,116.2c0-12.8,9.8-21.9,23.7-21.9c8.9,0,16,3.9,19,10.8l-9.6,5.2c-2.3-4-5.7-5.9-9.5-5.9 c-6.3,0-11.2,4.4-11.2,11.8S754,128,760.3,128c4,0,7.7-2.3,9.5-5.9l9.6,5.2c-3.1,6.8-10.1,10.8-19,10.8 C746.5,138.1,736.7,129,736.7,116.2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M785,82.2c0-3.9,3.1-6.9,7.7-6.9s7.6,2.8,7.6,6.6c0,3.8-3,7.1-7.6,7.1S785,86,785,82.2z M786.5,94.9h12.3v42.5 h-12.3V94.9z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M837.7,135.4c-2.5,1.8-6.2,2.7-10,2.7c-10,0-15.9-5.2-15.9-15.3v-17.4h-6.5v-9.5h6.5V85.5h12.4v10.4h10.5v9.4 h-10.6v17.3c0,3.7,2,5.6,5.3,5.6c1.8,0.1,3.5-0.5,5-1.5L837.7,135.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M886.1,94.9l-19.2,45.2c-4.2,10.2-10,13.3-17.6,13.3c-4.4,0-9.1-1.4-11.9-3.9l4.5-8.7c1.9,1.7,4.4,2.6,7,2.7 c3.4,0,5.3-1.5,7-5.3v-0.4l-18.4-42.9h12.7l12,28.9l12-28.9L886.1,94.9L886.1,94.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073700653325725637510000016746887611093062552_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.8,
    y1: 156.7003,
    x2: 376.2,
    y2: 156.7003,
    gradientTransform: "matrix(1 0 0 -1 -36.5 210.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#233562"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4A63A8"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183247260949260741990000016192594936150998701_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.2265,
    y1: 156.2705,
    x2: 376.8528,
    y2: 156.2705,
    gradientTransform: "matrix(1 0 0 -1 -36.5 210.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#243764"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#455E9F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073700653325725637510000016746887611093062552_)",
      stroke: "url(#SVGID_00000183247260949260741990000016192594936150998701_)",
      strokeMiterlimit: 10
    },
    d: " M259.5,15.5l-5.7,0.2c-28.3,1.5-54.6,14.9-72.5,36.9c3,7.5,4.5,15.5,4.5,23.5l0,0c0,5.4-0.7,10.8-2.1,16 c7.9-6.4,16.5-11.8,25.7-16.1c6.2-3,12.7-5.5,19.3-7.5c13.3-8.4,29.5-10.9,44.8-7c5.3,1.4,10.3,3.5,15,6.3c2.3,0.8,4.6,1.8,6.8,2.8 h2l1.4,0.2h4.3c14,0,27.3-5.9,36.7-16.3C320.4,29.8,290.8,15.4,259.5,15.5z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M480.9,170.3l-7.1,13.7v7.3h-4.2V184l-7.1-13.7h4.7l4.5,9.6l4.5-9.6H480.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M486.4,190.5c-1.3-0.7-2.3-1.7-3-3c-0.7-1.3-1.1-2.8-1.1-4.5s0.4-3.2,1.1-4.5s1.8-2.3,3.1-3s2.8-1.1,4.3-1.1 c1.6,0,3,0.4,4.4,1.1c1.3,0.7,2.3,1.7,3.1,3s1.1,2.8,1.1,4.5s-0.4,3.2-1.2,4.5c-0.8,1.3-1.8,2.3-3.1,3c-1.3,0.7-2.8,1.1-4.4,1.1 C489.1,191.5,487.7,191.2,486.4,190.5z M492.9,187.3c0.7-0.4,1.2-0.9,1.6-1.7c0.4-0.7,0.6-1.6,0.6-2.7c0-1.6-0.4-2.8-1.2-3.6 c-0.8-0.8-1.8-1.3-3-1.3s-2.2,0.4-3,1.3c-0.8,0.9-1.2,2.1-1.2,3.6s0.4,2.8,1.2,3.6c0.8,0.9,1.8,1.3,3,1.3 C491.5,187.9,492.2,187.7,492.9,187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M518.2,174.7v16.6h-4.2v-2.1c-0.5,0.7-1.2,1.3-2.1,1.7c-0.9,0.4-1.8,0.6-2.8,0.6c-1.3,0-2.5-0.3-3.5-0.8 c-1-0.5-1.8-1.4-2.4-2.4c-0.6-1.1-0.9-2.3-0.9-3.8v-9.8h4.2v9.2c0,1.3,0.3,2.3,1,3c0.7,0.7,1.6,1.1,2.7,1.1c1.2,0,2.1-0.4,2.7-1.1 s1-1.7,1-3v-9.2H518.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M528.6,175.2c0.9-0.5,1.9-0.8,3-0.8v4.4h-1.1c-1.3,0-2.3,0.3-3,0.9c-0.7,0.6-1,1.7-1,3.2v8.3h-4.2v-16.6h4.2 v2.6C527,176.4,527.7,175.7,528.6,175.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M552.4,191.3l-4.6-8.2h-2v8.2h-4.2v-20.9h7.9c1.6,0,3,0.3,4.1,0.9s2,1.3,2.6,2.3c0.6,1,0.9,2.1,0.9,3.3 c0,1.4-0.4,2.6-1.2,3.7c-0.8,1.1-2,1.9-3.6,2.3l5,8.5H552.4z M545.8,180h3.5c1.1,0,2-0.3,2.5-0.8s0.8-1.3,0.8-2.3 c0-1-0.3-1.7-0.8-2.2c-0.6-0.5-1.4-0.8-2.5-0.8h-3.5V180z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M576.1,184.2H564c0.1,1.2,0.5,2.1,1.3,2.8c0.7,0.7,1.7,1,2.7,1c1.6,0,2.7-0.7,3.3-2h4.5 c-0.5,1.6-1.4,2.9-2.8,3.9c-1.4,1-3,1.5-5,1.5c-1.6,0-3-0.4-4.3-1.1c-1.3-0.7-2.3-1.7-3-3c-0.7-1.3-1.1-2.8-1.1-4.5 c0-1.7,0.3-3.2,1-4.5s1.7-2.3,2.9-3s2.7-1,4.3-1c1.6,0,3,0.3,4.2,1c1.2,0.7,2.2,1.6,2.9,2.9c0.7,1.2,1,2.7,1,4.3 C576.2,183.2,576.2,183.7,576.1,184.2z M571.9,181.4c0-1.1-0.4-1.9-1.2-2.6c-0.8-0.6-1.7-1-2.8-1c-1,0-1.9,0.3-2.6,0.9 s-1.1,1.5-1.3,2.6H571.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M589.1,175.1c0.9,0.5,1.7,1.1,2.2,1.9v-2.4h4.2v16.7c0,1.5-0.3,2.9-0.9,4.1s-1.5,2.2-2.8,2.9s-2.7,1.1-4.5,1.1 c-2.4,0-4.3-0.6-5.8-1.7c-1.5-1.1-2.4-2.6-2.6-4.5h4.2c0.2,0.8,0.7,1.4,1.4,1.8c0.7,0.4,1.6,0.7,2.7,0.7c1.2,0,2.2-0.4,3-1.1 c0.8-0.7,1.1-1.8,1.1-3.3v-2.6c-0.5,0.8-1.3,1.4-2.2,2c-1,0.5-2,0.8-3.3,0.8c-1.4,0-2.7-0.4-3.8-1.1c-1.2-0.7-2.1-1.7-2.7-3 c-0.7-1.3-1-2.8-1-4.5c0-1.7,0.3-3.2,1-4.5s1.6-2.3,2.7-3c1.1-0.7,2.4-1,3.9-1C587,174.4,588.1,174.6,589.1,175.1z M590.7,180.3 c-0.4-0.7-0.9-1.3-1.6-1.7c-0.7-0.4-1.4-0.6-2.2-0.6s-1.5,0.2-2.2,0.6s-1.2,0.9-1.6,1.7c-0.4,0.7-0.6,1.6-0.6,2.6s0.2,1.9,0.6,2.6 c0.4,0.8,0.9,1.3,1.6,1.7c0.7,0.4,1.4,0.6,2.1,0.6c0.8,0,1.5-0.2,2.2-0.6c0.7-0.4,1.2-1,1.6-1.7c0.4-0.7,0.6-1.6,0.6-2.6 C591.3,181.9,591.1,181.1,590.7,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M615.3,174.7v16.6h-4.2v-2.1c-0.5,0.7-1.2,1.3-2.1,1.7c-0.9,0.4-1.8,0.6-2.8,0.6c-1.3,0-2.5-0.3-3.5-0.8 c-1-0.5-1.8-1.4-2.4-2.4c-0.6-1.1-0.9-2.3-0.9-3.8v-9.8h4.2v9.2c0,1.3,0.3,2.3,1,3s1.6,1.1,2.7,1.1c1.2,0,2.1-0.4,2.7-1.1 s1-1.7,1-3v-9.2H615.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M623.7,169.1v22.2h-4.2v-22.2H623.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M627.7,178.4c0.7-1.3,1.6-2.3,2.7-3c1.1-0.7,2.4-1,3.9-1c1.2,0,2.3,0.2,3.3,0.8c0.9,0.5,1.7,1.1,2.2,1.9v-2.4 h4.2v16.6h-4.2v-2.4c-0.5,0.8-1.3,1.4-2.2,1.9s-2,0.8-3.3,0.8c-1.4,0-2.7-0.4-3.8-1.1c-1.2-0.7-2.1-1.7-2.7-3c-0.7-1.3-1-2.8-1-4.5 C626.7,181.2,627.1,179.7,627.7,178.4z M639.2,180.3c-0.4-0.7-0.9-1.3-1.6-1.7c-0.7-0.4-1.4-0.6-2.2-0.6s-1.5,0.2-2.2,0.6 s-1.2,0.9-1.6,1.7c-0.4,0.7-0.6,1.6-0.6,2.6s0.2,1.9,0.6,2.6c0.4,0.8,0.9,1.3,1.6,1.7c0.7,0.4,1.4,0.6,2.1,0.6 c0.8,0,1.5-0.2,2.2-0.6c0.7-0.4,1.2-1,1.6-1.7c0.4-0.7,0.6-1.6,0.6-2.6C639.8,181.9,639.6,181.1,639.2,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M653,178.1v8c0,0.6,0.1,1,0.4,1.2s0.7,0.4,1.4,0.4h2v3.5h-2.6c-3.5,0-5.3-1.7-5.3-5.2v-8h-2v-3.5h2v-4.1h4.2 v4.1h3.7v3.5H653z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M660.1,172c-0.5-0.5-0.7-1.1-0.7-1.8s0.2-1.3,0.7-1.8c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.4,0.2,1.8,0.7 c0.5,0.5,0.7,1.1,0.7,1.8s-0.2,1.3-0.7,1.8s-1.1,0.7-1.8,0.7C661.2,172.7,660.6,172.4,660.1,172z M664,174.7v16.6h-4.2v-16.6H664z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M671.2,190.5c-1.3-0.7-2.3-1.7-3-3c-0.7-1.3-1.1-2.8-1.1-4.5s0.4-3.2,1.1-4.5s1.8-2.3,3.1-3 c1.3-0.7,2.7-1.1,4.3-1.1c1.6,0,3,0.4,4.3,1.1s2.3,1.7,3.1,3s1.1,2.8,1.1,4.5s-0.4,3.2-1.2,4.5c-0.8,1.3-1.8,2.3-3.1,3 c-1.3,0.7-2.8,1.1-4.4,1.1C673.9,191.5,672.5,191.2,671.2,190.5z M677.7,187.3c0.7-0.4,1.2-0.9,1.6-1.7c0.4-0.7,0.6-1.6,0.6-2.7 c0-1.6-0.4-2.8-1.2-3.6c-0.8-0.8-1.8-1.3-3-1.3c-1.2,0-2.2,0.4-3,1.3c-0.8,0.9-1.2,2.1-1.2,3.6s0.4,2.8,1.2,3.6 c0.8,0.9,1.8,1.3,3,1.3C676.3,187.9,677,187.7,677.7,187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M701.3,176.3c1.2,1.3,1.8,3,1.8,5.2v9.8h-4.2v-9.2c0-1.3-0.3-2.3-1-3c-0.7-0.7-1.6-1.1-2.7-1.1 c-1.2,0-2.1,0.4-2.7,1.1c-0.7,0.7-1,1.7-1,3v9.2h-4.2v-16.6h4.2v2.1c0.6-0.7,1.3-1.3,2.1-1.7c0.9-0.4,1.8-0.6,2.9-0.6 C698.5,174.4,700.1,175,701.3,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M727.4,171.6c1.7,0.9,3,2.1,3.9,3.7c0.9,1.6,1.4,3.4,1.4,5.5c0,2.1-0.5,3.9-1.4,5.5c-0.9,1.6-2.2,2.8-3.9,3.6 c-1.7,0.9-3.6,1.3-5.8,1.3h-7.3v-20.9h7.3C723.8,170.3,725.7,170.8,727.4,171.6z M726.5,185.9c1.2-1.2,1.8-2.9,1.8-5.1 c0-2.2-0.6-3.9-1.8-5.1c-1.2-1.2-2.9-1.8-5.1-1.8h-3v13.8h3C723.6,187.7,725.3,187.1,726.5,185.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M751.1,184.2h-12.2c0.1,1.2,0.5,2.1,1.3,2.8c0.7,0.7,1.7,1,2.7,1c1.6,0,2.7-0.7,3.3-2h4.5 c-0.5,1.6-1.4,2.9-2.8,3.9c-1.4,1-3,1.5-5,1.5c-1.6,0-3-0.4-4.3-1.1c-1.3-0.7-2.3-1.7-3-3c-0.7-1.3-1.1-2.8-1.1-4.5 c0-1.7,0.3-3.2,1-4.5s1.7-2.3,2.9-3s2.7-1,4.3-1c1.6,0,3,0.3,4.2,1c1.2,0.7,2.2,1.6,2.9,2.9c0.7,1.2,1,2.7,1,4.3 C751.2,183.2,751.2,183.7,751.1,184.2z M746.8,181.4c0-1.1-0.4-1.9-1.2-2.6c-0.8-0.6-1.7-1-2.8-1c-1,0-1.9,0.3-2.6,0.9 s-1.1,1.5-1.3,2.6H746.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M757,190.8c-1.1-0.5-1.9-1.2-2.6-2s-1-1.8-1-2.8h4.2c0.1,0.6,0.4,1.2,0.9,1.6c0.5,0.4,1.2,0.6,2.1,0.6 c0.8,0,1.4-0.2,1.9-0.5s0.7-0.7,0.7-1.2c0-0.5-0.3-0.9-0.8-1.2c-0.5-0.3-1.4-0.6-2.6-0.9c-1.2-0.3-2.3-0.6-3-0.9 c-0.8-0.3-1.5-0.8-2-1.5c-0.6-0.7-0.9-1.5-0.9-2.7c0-0.9,0.3-1.8,0.8-2.5c0.5-0.8,1.3-1.4,2.3-1.8c1-0.4,2.2-0.7,3.5-0.7 c2,0,3.6,0.5,4.7,1.5c1.2,1,1.8,2.3,2,4h-4c-0.1-0.7-0.3-1.2-0.8-1.6c-0.5-0.4-1.1-0.6-2-0.6c-0.8,0-1.3,0.1-1.8,0.4 s-0.6,0.7-0.6,1.2c0,0.6,0.3,1,0.8,1.3c0.6,0.3,1.4,0.6,2.6,0.9c1.2,0.3,2.2,0.6,3,0.9c0.8,0.3,1.5,0.8,2,1.5 c0.6,0.7,0.9,1.6,0.9,2.7c0,1-0.3,1.8-0.8,2.6c-0.5,0.8-1.3,1.4-2.3,1.8c-1,0.4-2.1,0.6-3.5,0.6C759.3,191.5,758,191.3,757,190.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M775.5,178.1v8c0,0.6,0.1,1,0.4,1.2s0.7,0.4,1.4,0.4h2v3.5h-2.6c-3.5,0-5.3-1.7-5.3-5.2v-8h-2v-3.5h2v-4.1h4.2 v4.1h3.7v3.5H775.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M782.5,172c-0.5-0.5-0.7-1.1-0.7-1.8s0.2-1.3,0.7-1.8c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.4,0.2,1.8,0.7 c0.5,0.5,0.7,1.1,0.7,1.8s-0.2,1.3-0.7,1.8s-1.1,0.7-1.8,0.7C783.6,172.7,783,172.4,782.5,172z M786.4,174.7v16.6h-4.2v-16.6H786.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M804.6,176.3c1.2,1.3,1.8,3,1.8,5.2v9.8h-4.2v-9.2c0-1.3-0.3-2.3-1-3c-0.7-0.7-1.6-1.1-2.7-1.1 c-1.2,0-2.1,0.4-2.7,1.1c-0.7,0.7-1,1.7-1,3v9.2h-4.2v-16.6h4.2v2.1c0.6-0.7,1.3-1.3,2.1-1.7c0.9-0.4,1.8-0.6,2.9-0.6 C801.8,174.4,803.4,175,804.6,176.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M810.3,178.4c0.7-1.3,1.6-2.3,2.7-3c1.1-0.7,2.4-1,3.9-1c1.2,0,2.3,0.2,3.3,0.8c0.9,0.5,1.7,1.1,2.2,1.9v-2.4 h4.2v16.6h-4.2v-2.4c-0.5,0.8-1.3,1.4-2.2,1.9s-2,0.8-3.3,0.8c-1.4,0-2.7-0.4-3.8-1.1c-1.2-0.7-2.1-1.7-2.7-3c-0.7-1.3-1-2.8-1-4.5 C809.3,181.2,809.7,179.7,810.3,178.4z M821.8,180.3c-0.4-0.7-0.9-1.3-1.6-1.7c-0.7-0.4-1.4-0.6-2.2-0.6s-1.5,0.2-2.2,0.6 s-1.2,0.9-1.6,1.7c-0.4,0.7-0.6,1.6-0.6,2.6s0.2,1.9,0.6,2.6c0.4,0.8,0.9,1.3,1.6,1.7c0.7,0.4,1.4,0.6,2.1,0.6 c0.8,0,1.5-0.2,2.2-0.6c0.7-0.4,1.2-1,1.6-1.7c0.4-0.7,0.6-1.6,0.6-2.6C822.4,181.9,822.2,181.1,821.8,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M835.6,178.1v8c0,0.6,0.1,1,0.4,1.2s0.7,0.4,1.4,0.4h2v3.5h-2.6c-3.5,0-5.3-1.7-5.3-5.2v-8h-2v-3.5h2v-4.1h4.2 v4.1h3.7v3.5H835.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M842.7,172c-0.5-0.5-0.7-1.1-0.7-1.8s0.2-1.3,0.7-1.8c0.5-0.5,1.1-0.7,1.8-0.7c0.7,0,1.4,0.2,1.8,0.7 c0.5,0.5,0.7,1.1,0.7,1.8s-0.2,1.3-0.7,1.8s-1.1,0.7-1.8,0.7C843.8,172.7,843.2,172.4,842.7,172z M846.6,174.7v16.6h-4.2v-16.6 H846.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M853.8,190.5c-1.3-0.7-2.3-1.7-3-3c-0.7-1.3-1.1-2.8-1.1-4.5s0.4-3.2,1.1-4.5s1.8-2.3,3.1-3 c1.3-0.7,2.7-1.1,4.3-1.1c1.6,0,3,0.4,4.3,1.1s2.3,1.7,3.1,3s1.1,2.8,1.1,4.5s-0.4,3.2-1.2,4.5c-0.8,1.3-1.8,2.3-3.1,3 c-1.3,0.7-2.8,1.1-4.4,1.1C856.5,191.5,855.1,191.2,853.8,190.5z M860.3,187.3c0.7-0.4,1.2-0.9,1.6-1.7c0.4-0.7,0.6-1.6,0.6-2.7 c0-1.6-0.4-2.8-1.2-3.6c-0.8-0.8-1.8-1.3-3-1.3c-1.2,0-2.2,0.4-3,1.3c-0.8,0.9-1.2,2.1-1.2,3.6s0.4,2.8,1.2,3.6 c0.8,0.9,1.8,1.3,3,1.3C858.9,187.9,859.6,187.7,860.3,187.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M883.9,176.3c1.2,1.3,1.8,3,1.8,5.2v9.8h-4.2v-9.2c0-1.3-0.3-2.3-1-3c-0.7-0.7-1.6-1.1-2.7-1.1 c-1.2,0-2.1,0.4-2.7,1.1c-0.7,0.7-1,1.7-1,3v9.2h-4.2v-16.6h4.2v2.1c0.6-0.7,1.3-1.3,2.1-1.7c0.9-0.4,1.8-0.6,2.9-0.6 C881.1,174.4,882.7,175,883.9,176.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcLogo);
export default __webpack_public_path__ + "static/media/RC_Logo.cead403355c23f1cef65d6afed5db84c.svg";
export { ForwardRef as ReactComponent };